import { Component, computed, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { BreadcrumbComponent } from '../../../../shared/components/breadcrumb/breadcrumb.component';
import { LucideModule } from '../../../../shared/modules/lucide.module';
import { AgendamentoComponent } from './agendamento/agendamento.component';
import { MeusAgendamentosComponent } from './meus-agendamentos/meus-agendamentos.component';
import { MinhasSolicitacoesComponent } from './minhas-solicitacoes/minhas-solicitacoes.component';
import { DadosPessoaisComponent } from './dados-pessoais/dados-pessoais.component';
import { ServicosFavoritosComponent } from './servicos-favoritos/servicos-favoritos.component';
import { TodosServicosUsuarioLogadoComponent } from '../../todos-servicos/todos-servicos-usuario-logado/todos-servicos-usuario-logado.component';

interface SecaoAreaCidadao {
  id: 'agendamento' | 'meus-agendamentos' | 'solicitacoes' | 'dados' | 'favoritos';
  titulo: string;
  icone: string;
}

const SECOES: readonly SecaoAreaCidadao[] = [
  { id: 'agendamento', titulo: 'Agendamento', icone: 'calendar' },
  { id: 'meus-agendamentos', titulo: 'Meus agendamentos', icone: 'calendar-check' },
  { id: 'solicitacoes', titulo: 'Minhas solicitações', icone: 'file-text' },
  { id: 'dados', titulo: 'Dados pessoais', icone: 'user' },
  { id: 'favoritos', titulo: 'Serviços favoritos', icone: 'heart' },
];

@Component({
  selector: 'app-area-cidadao',
  templateUrl: './area-cidadao.component.html',
  styleUrls: ['./area-cidadao.component.css'],
  imports: [LucideModule, RouterLink, BreadcrumbComponent, TodosServicosUsuarioLogadoComponent, AgendamentoComponent, MeusAgendamentosComponent, MinhasSolicitacoesComponent, DadosPessoaisComponent, ServicosFavoritosComponent],
})
export class AreaCidadaoComponent {
  readonly secoes = SECOES;

  readonly aba = input('');

  /** A aba ativa vem da query string "?aba=", para que a URL reflita a navegação do menu. */
  readonly secaoAtiva = computed<SecaoAreaCidadao['id']>(() => {
    const aba = this.aba();
    return SECOES.find((secao) => secao.id === aba)?.id ?? 'agendamento';
  });

  readonly tituloSecao = computed(
    () => this.secoes.find((secao) => secao.id === this.secaoAtiva())?.titulo ?? ''
  );
}
